import {Box, IconButton, Paper, Stack, Typography} from "@mui/material";
import {CollectionsBookmarkOutlined} from "@mui/icons-material";
import pleshDark from "../../theme/pleshDark";
import {THEME_CONFIG} from "../../config";
import { useTranslation } from 'react-i18next';

const {agendaStyle} = THEME_CONFIG


const CustomCard = ({
    agenda = true,
    label,
    icon,
    body,
    borderStyle = 'solid',
    backgroundColor = agendaStyle.headerColor,
    children
}) => {
    const { t } = useTranslation('components');
    
    return (
        <Paper elevation={8} sx={{
            boxShadow: agendaStyle.boxShadow,
            borderRadius: agendaStyle.borderRadius,
            //border: `2px ${borderStyle} rgba(0,0,0,0.1)`,
            overflowY: 'hidden',
            position: 'relative',
            border: '1px solid ' + agendaStyle.headerColor
        }}>
            <Stack px={1} py={0.5}
                   direction='row'
                   justifyContent={'end'}
                   alignItems={'center'}
                   spacing={1}
                   sx={{
                       backgroundColor: backgroundColor || pleshDark.palette.primary.main
            }}
            >
                <Typography textAlign='right'
                            variant='body1'
                            fontWeight={'bold'}
                            color={agendaStyle.headerTextColor}
                            whiteSpace='pre-line'
                >
                    {label || t('agenda.title')}
                </Typography>
              {icon || <CollectionsBookmarkOutlined sx={{color:agendaStyle.iconColor}} fontSize='small'/>}
            </Stack>
            <Box minHeight={'70px'} display={'contents'} justifyContent={'flex-start'} alignItems={'center'}>
                <Typography textAlign='center' whiteSpace='pre-line'>
                    {body?.slice(0,100)||''}{body?.length > 100 ? ' ...' : ''}
                </Typography>
                {children}
            </Box>
        </Paper>
    )
}

export default CustomCard;